import React, { Fragment, useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import SvgIcon from "../../Components/Common/Component/SvgIcon";
import CustomizerContext from "../../_helper/Customizer";
import { MENUITEMS } from "./Menu";
import { useAuth } from "../../_helper/Admin/AdminProvider";

const SidebarMenuItems = ({ setMainMenu, sidebartoogle, setNavActive, activeClass }) => {
  const { layout } = useContext(CustomizerContext);
  const layout1 = localStorage.getItem("sidebar_layout") || layout;

  const id = window.location.pathname.split("/").pop();
  const layoutId = id;
  const CurrentPath = window.location.pathname;

  const { t } = useTranslation();
  const { admin, role_code } = useAuth();
  const currentRole = role_code || admin?.role_code || null;

  const canView = (item) => {
    if (!item) return false;
    if (!item.allowedRoles || item.allowedRoles.length === 0) return true;
    if (!currentRole) return false;
    return item.allowedRoles.includes(currentRole);
  };

  const filteredMenu = useMemo(() => {
    return MENUITEMS.map((section) => {
      const visibleItems = section.Items.filter((menuItem) => {
        if (!canView(menuItem)) return false;
        if (!menuItem.children || menuItem.children.length === 0) return true;
        return menuItem.children.some(canView);
      });
      return { ...section, Items: visibleItems };
    }).filter((section) => section.Items.length > 0);
  }, [currentRole]);

  const toggletNavActive = (item) => {
    if (window.innerWidth <= 991) {
      document.querySelector(".page-header").className = "page-header close_icon";
      document.querySelector(".sidebar-wrapper").className = "sidebar-wrapper close_icon ";
      if (item.type === "sub") {
        document.querySelector(".page-header").className = "page-header";
        document.querySelector(".sidebar-wrapper").className = "sidebar-wrapper";
      }
    }
    if (!item.active) {
      MENUITEMS.map((a) => {
        a.Items.filter((Items) => {
          if (a.Items.includes(item)) Items.active = false;
          if (!Items.children) return false;
          Items.children.forEach((b) => {
            if (Items.children.includes(item)) {
              b.active = false;
            }
            if (!b.children) return false;
            b.children.forEach((c) => {
              if (b.children.includes(item)) {
                c.active = false;
              }
            });
          });
          return Items;
        });
        return a;
      });
    }
    item.active = !item.active;
    setMainMenu({ mainmenu: MENUITEMS });
  };

  if (filteredMenu.length === 0) {
    return null;
  }

  return (
    <>
      {filteredMenu.map((Item, i) => (
        <Fragment key={i}>
          <li className="sidebar-main-title">
            <div>
              <h6 className="lan-1">{t(Item.menutitle)}</h6>
            </div>
          </li>
          {Item.Items.map((menuItem, i) => {
            const visibleChildren = (menuItem.children || []).filter(canView);
            if (menuItem.type === "sub" && visibleChildren.length === 0) {
              return null;
            }

            return (
              <li className="sidebar-list" key={i}>
                {menuItem.type === "sub" ? (
                  <a
                    href="javascript"
                    className={`sidebar-link sidebar-title ${CurrentPath.includes(menuItem.title.toLowerCase()) ? "active" : ""} ${menuItem.active && "active"}`}
                    onClick={(event) => {
                      event.preventDefault();
                      setNavActive(menuItem);
                      activeClass(menuItem.active);
                    }}>
                    <SvgIcon className="stroke-icon" iconId={`stroke-${menuItem.icon}`} />
                    <SvgIcon className="fill-icon" iconId={`fill-${menuItem.icon}`} />
                    <span>{t(menuItem.title)}</span>
                    {menuItem.badge ? <label className={menuItem.badge}>{menuItem.badgetxt}</label> : ""}
                    <div className="according-menu">{menuItem.active ? <i className="fa fa-angle-down"></i> : <i className="fa fa-angle-right"></i>}</div>
                  </a>
                ) : (
                  ""
                )}

                {menuItem.type === "link" && canView(menuItem) ? (
                  <Link to={menuItem.path + "/" + layoutId} className={`sidebar-link sidebar-title link-nav  ${CurrentPath.includes(menuItem.title.toLowerCase()) ? "active" : ""}`} onClick={() => toggletNavActive(menuItem)}>
                    <SvgIcon className="stroke-icon" iconId={`stroke-${menuItem.icon}`} />
                    <SvgIcon className="fill-icon" iconId={`fill-${menuItem.icon}`} />
                    <span>{t(menuItem.title)}</span>
                    {menuItem.badge ? <label className={menuItem.badge}>{menuItem.badgetxt}</label> : ""}
                  </Link>
                ) : (
                  ""
                )}

                {menuItem.children && visibleChildren.length > 0 ? (
                  <ul className="sidebar-submenu" style={layout1 !== "compact-sidebar compact-small" ? (menuItem?.active || CurrentPath.includes(menuItem?.title?.toLowerCase()) ? (sidebartoogle ? { opacity: 1, transition: "opacity 500ms ease-in" } : { display: "block" }) : { display: "none" }) : { display: "none" }}>
                    {visibleChildren.map((childrenItem, index) => {
                      const visibleSubChildren = (childrenItem.children || []).filter(canView);
                      const hasSubChildren = visibleSubChildren.length > 0;

                      return (
                        <li key={index}>
                          {childrenItem.type === "sub" ? (
                            <a
                              href="javascript"
                              className={`${CurrentPath.includes(childrenItem?.title?.toLowerCase()) ? "active" : ""}`}
                              onClick={(event) => {
                                event.preventDefault();
                                toggletNavActive(childrenItem);
                              }}>
                              {t(childrenItem.title)}
                              <span className="sub-arrow">
                                <i className="fa fa-chevron-right"></i>
                              </span>
                              <div className="according-menu">{childrenItem.active ? <i className="fa fa-angle-down"></i> : <i className="fa fa-angle-right"></i>}</div>
                            </a>
                          ) : (
                            ""
                          )}

                          {childrenItem.type === "link" && canView(childrenItem) ? (
                            <Link
                              to={childrenItem.path + "/" + layoutId}
                              className={`${CurrentPath.includes(childrenItem?.title?.toLowerCase()) ? "active" : ""}`}
                              onClick={() => toggletNavActive(childrenItem)}>
                              {t(childrenItem.title)}
                            </Link>
                          ) : (
                            ""
                          )}

                          {hasSubChildren ? (
                            <ul className="nav-sub-childmenu submenu-content" style={CurrentPath.includes(childrenItem?.title?.toLowerCase()) || childrenItem.active ? { display: "block" } : { display: "none" }}>
                              {visibleSubChildren.map((childrenSubItem, key) => (
                                <li key={key}>
                                  {childrenSubItem.type === "link" && canView(childrenSubItem) ? (
                                    <Link
                                      to={childrenSubItem.path + "/" + layoutId}
                                      className={`${CurrentPath.includes(childrenSubItem?.title?.toLowerCase()) ? "active" : ""}`}
                                      onClick={() => toggletNavActive(childrenSubItem)}>
                                      {t(childrenSubItem.title)}
                                    </Link>
                                  ) : (
                                    ""
                                  )}
                                </li>
                              ))}
                            </ul>
                          ) : (
                            ""
                          )}
                        </li>
                      );
                    })}
                  </ul>
                ) : (
                  ""
                )}
              </li>
            );
          })}
        </Fragment>
      ))}
    </>
  );
};

export default SidebarMenuItems;
